/**
 * Configuration
 *
 * Environment variables and feature toggles
 */

export const ENV = `${import.meta.env.VITE_ENV}` || "dev";

export const isSystemPromptFeatureEnabled = (userEmail: string): boolean => {
  if (ENV === "prod" || ENV === "production") {
    return false;
  }

  const allowedUsersEnv = import.meta.env.VITE_SYSTEM_PROMPT_ALLOWED_USERS;
  if (!allowedUsersEnv) {
    return false;
  }

  const allowedUsers = allowedUsersEnv.split(",").map((email: string) => email.trim().toLowerCase());

  return allowedUsers.includes(userEmail.toLowerCase());
};
